import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// apollo
import { Query } from 'components/common/Query';

class StatsPeriod extends Component {
  constructor(props) {
    super(props);
    const { defaultLast } = this.props;
    const now = moment();
    const minDateTime = moment().subtract(1, defaultLast);
    this.state = {
      minDateTime,
      maxDateTime: now,
    };
    this.fetchMore = () => {};
  }

  /**
   * @description
   * Called when Stats component need updated data
   * @param {Object} dates - Dates interval needed.
   * @returns {Function} - Fetch More function.
   */
  handleUpdateData = ({ minDateTime, maxDateTime }) => {
    this.setState({
      minDateTime,
      maxDateTime,
    });
    this.fetchMore({
      updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
    });
  };

  render() {
    const { minDateTime, maxDateTime } = this.state;
    const { query, children } = this.props;
    return (
      <Query
        query={query}
        variables={{
          minDate: moment(minDateTime).format('YYYY-MM-DD'),
          maxDate: moment(maxDateTime).format('YYYY-MM-DD'),
        }}
        fetchPolicy="network-only"
      >
        {({ data, fetchMore }) => {
          this.fetchMore = fetchMore;
          return children({
            data,
            updateData: this.handleUpdateData,
          });
        }}
      </Query>
    );
  }
}

/**
 * StatsPeriod PropTypes
 * @param query - graphql query
 * @param children - function for render props
 * @param defaultLast - string used for calculate the minDate.
 * Valid values are: day, week, month, etc
 */

StatsPeriod.propTypes = {
  query: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.func.isRequired,
  defaultLast: PropTypes.string,
};

StatsPeriod.defaultProps = {
  defaultLast: 'day',
};
export default StatsPeriod;
